// src/config/config.ts - Bare minimum config
import { initializeConfig } from "@fraktion/core-frontend";

// Super simple environment access
export function getEnvironment() {
  // Basic environment with direct access to env vars
  const environment = {
    // Core config
    mode: import.meta.env.MODE,
    appName: import.meta.env.VITE_APP_NAME || "",
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || "",
    authBaseUrl: import.meta.env.VITE_AUTH_BASE_URL || "",
    authType: import.meta.env.VITE_AUTH_TYPE || "jwt",
    authStorage: import.meta.env.VITE_AUTH_STORAGE || "local",
    websiteUrl: import.meta.env.VITE_WEBSITE_URL || "",
    stripePublicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY || "",
    defaultTheme: import.meta.env.VITE_DEFAULT_THEME || "light",
    tenantId: import.meta.env.VITE_TENANT_ID || "",
    requiredRole: import.meta.env.VITE_REQUIRED_ROLE,
    onboardingEnabled: import.meta.env.VITE_ONBOARDING_ENABLED === "true",
    onboardingSteps: (import.meta.env.VITE_ONBOARDING_STEPS || "")
      .split(",")
      .filter(Boolean),
    jwtRefreshTokenKey:
      import.meta.env.VITE_JWT_REFRESH_TOKEN_KEY || "refresh_token",
    jwtAccessTokenKey:
      import.meta.env.VITE_JWT_ACCESS_TOKEN_KEY || "access_token",
    authToken: import.meta.env.VITE_AUTH_TOKEN,
    kycProvider: import.meta.env.VITE_KYC_PROVIDER || "dataleon",
    signatureProvider: import.meta.env.VITE_SIGNATURE_PROVIDER || "signaturit",
    paymentProvider: import.meta.env.VITE_PAYMENT_PROVIDER || "bridgeapi",
    paymentProviders: (
      import.meta.env.VITE_PAYMENT_PROVIDERS || "bridgeapi,mangopay"
    )
      .split(",")
      .filter(Boolean),

    // Deployment specific
    deploymentProvider: import.meta.env.VITE_DEPLOYMENT_PROVIDER || "",
    awsRegion: import.meta.env.VITE_AWS_REGION || "",
    s3Bucket: import.meta.env.VITE_S3_BUCKET || "",
    environment: import.meta.env.VITE_ENVIRONMENT || "development",
    stage: import.meta.env.VITE_STAGE || "development",
    mediaBaseUrl: import.meta.env.VITE_MEDIA_BASE_URL || "",
    cloudfrontDomain: import.meta.env.VITE_CLOUDFRONT_DOMAIN || "",
    cloudfrontDistributionId:
      import.meta.env.VITE_CLOUDFRONT_DISTRIBUTION_ID || "",
  };

  // Initialize core
  initializeConfig({
    MODE: environment.mode,
    AUTH_TOKEN: environment.authToken,
    API_BASE_URL: environment.apiBaseUrl,
    AUTH_BASE_URL: environment.authBaseUrl,
    AUTH_TYPE: environment.authType,
    AUTH_STORAGE: environment.authStorage,
    WEBSITE_URL: environment.websiteUrl,
    STRIPE_PUBLIC_KEY: environment.stripePublicKey,
    DEFAULT_THEME: environment.defaultTheme,
    APP_NAME: environment.appName,
    TENANT_ID: environment.tenantId,
    REQUIRED_ROLE: environment.requiredRole,
    KYC_PROVIDER: environment.kycProvider,
    SIGNATURE_PROVIDER: environment.signatureProvider,
    PAYMENT_PROVIDER: environment.paymentProvider,
    PAYMENT_PROVIDERS: environment.paymentProviders,
    ONBOARDING: {
      ENABLED: environment.onboardingEnabled,
      STEPS: environment.onboardingSteps,
    },
    JWT: {
      REFRESH_TOKEN_KEY: environment.jwtRefreshTokenKey,
      ACCESS_TOKEN_KEY: environment.jwtAccessTokenKey,
    },
  });

  return environment;
}

// Simple deployment config
export function getDeploymentConfig() {
  const env = getEnvironment();
  return {
    environment: env.environment,
    region: env.awsRegion,
    stage: env.stage,
    apiEndpoints: {
      main: env.apiBaseUrl,
      auth: env.authBaseUrl,
      media: env.mediaBaseUrl,
    },
    storage: {
      bucket: env.s3Bucket,
      region: env.awsRegion,
      cloudfront: {
        domain: env.cloudfrontDomain,
        distributionId: env.cloudfrontDistributionId,
      },
    },
  };
}
